import { AuthFlowTypes } from "./types";

export const authFlowTypes: AuthFlowTypes = {
  newUsers: "first_time_login",
  forgotPassword: "forgot_password",
};
